module.exports = __webpack_public_path__ + "510ebe823f3701e6c994dbb6d5b86ab0.svg";